var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2213_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2521 22.3183C41.2521 22.2126 41.2393 22.1062 41.2124 22.0014C40.3728 18.7039 38.1232 16.0102 35.1429 14.5291V17.1429C35.1429 17.8529 34.5679 18.4286 33.8572 18.4286C33.1465 18.4286 32.5715 17.8529 32.5715 17.1429V13.6467V13.2857C32.5715 12.5756 31.9959 12 31.2857 12H28.7143C28.0042 12 27.4286 12.5756 27.4286 13.2857V13.6465V17.1429C27.4286 17.8529 26.8529 18.4286 26.1429 18.4286C25.4328 18.4286 24.8571 17.8529 24.8571 17.1429V14.5291C21.8762 16.0101 19.6266 18.7039 18.787 22.0014C18.7603 22.1063 18.7508 22.2124 18.7558 22.3175C17.8417 22.4689 17.1428 23.2574 17.1428 24.2143C17.1428 25.2795 18.0063 26.1429 19.0714 26.1429H40.9287C41.9938 26.1429 42.8572 25.2795 42.8572 24.2143C42.8572 23.26 42.1624 22.4728 41.2521 22.3183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 28.7148H21V30.0006C21 32.4551 21.99 34.681 23.5887 36.3063C23.5846 36.3477 23.5714 36.3869 23.5714 36.4292V38.5937L29.968 41.4364L36.4286 38.2059V36.4292C36.4286 36.3869 36.4155 36.3476 36.4114 36.306C38.0101 34.6808 39.0001 32.4549 39.0001 30.0006V28.7148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2856 47.9999H37.7143V40.4375L30.575 44.0071C30.3942 44.0975 30.1971 44.1427 30 44.1427C29.8223 44.1427 29.644 44.1057 29.4776 44.0316L22.2856 40.8352V47.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7143 40.4297C16.6526 41.3675 13.9946 43.3325 12.216 46.001C11.9529 46.3953 11.9284 46.9025 12.1519 47.3207C12.3761 47.7388 12.8118 47.9999 13.2857 47.9999H19.7143V40.4297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7843 46.0009C46.0058 43.3325 43.348 41.3676 40.2859 40.4297V47.9998H46.7145C47.1891 47.9998 47.6248 47.7386 47.8483 47.3205C48.0718 46.9024 48.0467 46.3951 47.7843 46.0009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2213_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon_01.55a05128666d279d0a918c648852ac99.svg";
export { ForwardRef as ReactComponent };